import InitialState from '../initial-state';
import * as ActionName from '../action-names';
import Global from '../../global';
import { ActionTypes } from '../app-data/actions';

export default function highlightsReducer(state = InitialState.getState().highlightsStrip, action) {
  switch (action.type) {
    case ActionName.HIGHLIGHTS_DATA_LOAD_SUCCESS: {
      const id = action.payload && action.payload.length ? action.payload[0].id : null;

      // if action.payload.sportIdsWithEventList.length === 1 means that the request was made for only one group
      const sportIndex = action.payload.sportIdsWithEventList.length === 1
        ? state.sportIdsWithEventList.findIndex(sport => sport.id === action.payload.sportIdsWithEventList[0].id)
        : -1;
      let newSportIdsWithEventList = [...state.sportIdsWithEventList];

      if (sportIndex >= 0) {
        newSportIdsWithEventList = [...state.sportIdsWithEventList];
        newSportIdsWithEventList[sportIndex] = { ...action.payload.sportIdsWithEventList[0] };
      } else {
        newSportIdsWithEventList = action.payload.sportIdsWithEventList;
      }

      return {
        ...state,
        activeSportId: state.activeSportId ? state.activeSportId : id,
        sportIdsWithEventList: newSportIdsWithEventList,
        sportGroups: {
          ...state.sportGroups,
          ...action.payload.sportGroups
        }
      };
    }
    case ActionName.HIGHLIGHTS_CHANGE_ACTIVE_SPORT: {
      Global.logger.warn(`Changed sport to ${action.id} `);
      return {
        ...state,
        activeSportId: action.id
      };
    }
    case ActionTypes.REMOVE_EVENT: {
      const eventId = action.payload;
      let sportIdsWithEventList = [...state.sportIdsWithEventList];
      sportIdsWithEventList.forEach(sport => {
        sport.eventIds = sport.eventIds.filter(id => id !== eventId);
      });
      sportIdsWithEventList = sportIdsWithEventList.filter(sport => sport.eventIds.length > 0);

      return {
        ...state,
        sportIdsWithEventList: sportIdsWithEventList
      };
    }
    default:
      return state;
  }
}
